import { store } from './store';

/**
 * MediaSelectModal
 * @params options Object
 *
 */
window.mediaSelectModal = (options) => {

    store.dispatch('showMediaSelectModal', options);

    return new Promise((resolve, reject) => {

        if (options.strategy === 'SelectMedia') {
            const unwatch = store.watch(
                (state, getters) => getters.getMediaSelectModalShow,
                (value) => {
                    if (!value) {
                        resolve(null);
                    }
                    unwatch();
                }
            );
        }

        const strategyManager = store.getters.getMediaSelectStrategyManager;
        const unwatch2 = store.watch(
            (state, getters) => getters.getMediaSelectActionCalled,
            (value) => {
                if (value === true) {
                    unwatch2();
                    strategyManager
                        .doAction()
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((reason) => {
                            reject(reason);
                        })
                        .finally(() => {
                            store.commit('setMediaSelectActionCalled', false);
                        });
                }
            }
        );
    }).catch((error) => {
        console.error(error);
    });
};
